'use client'

import CreationToolOutputType from 'creation/src/creation-tools/types/output-type'
import { useRouter } from 'next/navigation'
import { ReactNode } from 'react'
import { useCreationStore } from './store/provider'

type Props = {
    children?: ReactNode
}

// Legacy components/icons.tsx:209-216 (BackArrowIcon), reproduced verbatim —
// not shared via presentation/icons.ts because that module only holds icons
// keyed off the output-type/welcome-button switches, not one-off glyphs.
const BackArrowIcon = () => (
    <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg">
        <g fill="#FFF" fillRule="nonzero">
            <path d="M18.758 25.178a1 1 0 101.364-1.462L9.798 14.013c-.404-.376-1.112-.354-1.49.05a1 1 0 00.05 1.413l10.4 9.702z" />
            <path d="M9.722 15.476a1 1 0 01-1.364-1.463l10.4-9.702a1 1 0 011.364 1.463l-10.4 9.702z" />
        </g>
    </svg>
)

/**
 * Ported from legacy components/navigation.tsx. `outputType`/`sources` come
 * from the store instead of CreationToolsContext.
 */
const Navigation = ({ children }: Props) => {
    const outputType = useCreationStore((state) => state.outputType)
    const sources = useCreationStore((state) => state.sources)
    const router = useRouter()

    const onBackClick = () => {
        // Legacy navigation.tsx:38-44. The trimmer is skipped for animated
        // sticker sources (see the layout effect in video-trim-step), so
        // history.back() would bounce the user straight forward again. A
        // hard navigation is the deliberate escape — preserved exactly,
        // quirk included.
        if (outputType === CreationToolOutputType.Sticker && sources[0]?.isAnimated) {
            window.location.href = '/create/gifmaker'
        } else {
            router.back()
        }
    }

    return (
        <div className="mb-[20px] flex h-[36px] w-full items-center text-[17px] font-bold">
            <div data-testid="back" onClick={onBackClick} className="mr-auto flex cursor-pointer items-center">
                <BackArrowIcon />
                <span className="px-[8px]">Back</span>
            </div>
            {children}
        </div>
    )
}

export default Navigation
